import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import {map, take} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AppConfigService, SessionStorageService} from '@ox/utils';
import {TrackingService} from '@ox/data';
import {Vehicle} from '@ox/typings';
import {ConfirmationModalComponent} from '../confirmation-modal/confirmation-modal.component';
import {TranslateService} from '@ox/translate';

@Component({
  selector: 'webu-add-mileage',
  templateUrl: './add-mileage.component.html'
})
export class AddMileageComponent implements OnInit {
  //@Input() mileage: string; from warrantytracker, does not make sense to bring in the mileage from parent since it will always be empty
  // @Input() odometerLastUpdated: any; // (not being used)
  @Input() addMileageSuccessCallback: any; // function from warrantytracker
  //@Input() addMileageBtnClicked: any; //not found
  // @Input() closeModal: any; // (not being used)
  @Input() activeVehicle: Vehicle; //from vehiclesnapshot
  // @Input() mileageAdded:any; //from vehiclesnapshot
  @Input() activeVehicleMileageState:any;
  // @Input() vehicle:any;
  @Input() showAddMileageError:any;
  @Output() activeVehicleMileageStateChange = new EventEmitter<string>();
  @Output() vehicleMileageUpdate = new EventEmitter<any>();

  public mileageForm: FormGroup;
  public language:any;
  public odometerAttributes: any = this.appConfigService.fieldAttributes.vehicle.odometer;
  public submitted:boolean;
  //public showAddMileageError:boolean;
  public invalidMileageError:boolean;
  public addMileageForm: FormGroup;

  public miles: any = '';
  public showConfirmationModal = false;
  public confirmationModal = ConfirmationModalComponent;
  public confirmationModalStyling = {
    class: 'modal-confirmation',
    backdrop: true,
    ignoreBackdropClick: false
  };
  public confirmationOutputs = {
    optionEvent: new EventEmitter()
  };
  public confirmationInputs = { 
    firstOption: '' ,
    secondOption:'',

    titleText:'',

    confirmationText:'',

    id: 'addMilageConfirmationModal'
   };

  constructor(
    private appConfigService: AppConfigService,
    private trackingService: TrackingService,
    private sessionStorageService: SessionStorageService,
    private translateService:TranslateService,
    //private utilitiesService: UtilitiesService, used for safeapply not sure if needed for angular 2+
    //private garageService: GarageService, need to implement
    private fb: FormBuilder
  ) {
    this.addMileageForm = this.fb.group({
      addMileageInput: new FormControl('', [
        Validators.maxLength(this.odometerAttributes.maxlength),
        Validators.pattern(this.odometerAttributes.pattern),
        Validators.required
      ])
    });
}

  ngOnInit(): void {
    this.language = this.appConfigService.bml.lang;
    this.translateService.get(['addMileageModal_cancel_confirmationFirstOptionText','addMileageModal_cancel_confirmationSecondOptionText',
    'addMileageModal_cancel_confirmationTitle','addMileageModal_cancel_confirmationText']).subscribe((translations) => {
      this.confirmationInputs.firstOption = translations.addMileageModal_cancel_confirmationFirstOptionText;
      this.confirmationInputs.secondOption = translations.addMileageModal_cancel_confirmationSecondOptionText;
      this.confirmationInputs.titleText = translations.addMileageModal_cancel_confirmationTitle;
      this.confirmationInputs.confirmationText = translations.addMileageModal_cancel_confirmationText;
    });
  }

  public dismissAddModal(): void {
    if (this.addMileageForm.dirty) {
      this.showConfirmationModal = true;

      this.confirmationOutputs.optionEvent.pipe(
          map(($event: string) => {
            if($event === 'first') {
              this.sureClose();
            }
            else if($event === 'second') {
              this.notSureClose();
            }
          })
        ).subscribe();
      
    } else {
      this.submitted = false;
      this.miles = null;
      this.invalidMileageError = false;
      this.activeVehicleMileageStateChange.emit('addMileage');
    }
    this.showAddMileageError = false;
  }

  public sureClose(): void {
    this.showConfirmationModal = false;
    this.submitted = false;
    this.miles = null;
    this.invalidMileageError = false;
    this.showAddMileageError = false;
    this.activeVehicleMileageStateChange.emit('addMileage');
  }

  public notSureClose(): void {
    this.showConfirmationModal = false;
  }

  public addMileage(): void {
    console.log(this.addMileageForm.controls['addMileageInput'].value, 'this.miles');
    this.miles = this.addMileageForm.controls['addMileageInput'].value;
    this.submitted = true;

    /* istanbul ignore else*/ //for unit test to ignore else branch
    if (this.miles !== undefined && this.miles !== null) {
      const mileage = parseInt(this.miles);
      if (mileage === 0 || this.miles > 999999) {
        this.invalidMileageError = true;
        this.trackingService.trackEvent('event20', 'activeVehicle.invalidMileageError');
        return;
      }

      this.updateMileageSave(this.miles);
      this.showConfirmationModal = false;
      this.miles = null;
      this.invalidMileageError = false;
      this.showAddMileageError = false;
      }
    }

    public updateMileageSave(miles:string) {
      if (this.addMileageForm?.valid) {
        this.vehicleMileageUpdate.emit({odometer:miles,message:'addSuccess'});
      }
    }
}
